import { Radio, Tooltip, message } from "antd";
import React, { useState } from "react";
import Buttons from "../../../base/basicComponents/button";
import NormalSpin from "../../../base/basicComponents/spin";
import changeHistoryService from "../../../service/changeHistory";
import ListColumnBase from "../../commonComponents/listBase/listColumnBase";
import changeHistoryFilterMap from "../../commonComponents/listTable/changeHistoryListFilterMap";
import { GetColumnCheckboxGroupFilterDropdown } from "../../commonComponents/listTable/CustomFilter";
import styles from "../procedureList/index.module.scss";
import toDoListStyles from "../toDoList/index.module.scss";
import "../toDoList/index.scss";
import ChangeHistoryListTable from "./changeHistorySection/changeHistoryListTable";
import TopFilter from "./changeHistorySection/topFilter";
import changeHistoryStyle from "./index.module.scss";
import "./index.scss";

export default function ChangeHistory(props: any) {
  const getRoutingParam = (paramName: any) => {
    if (props.match === undefined) {
      return props.params[paramName];
    } else if (props.match === null || props.match.params == null) {
      return;
    }
    return props.match.params[paramName];
  };

  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(1);
  const [isExpend, setIsExpend] = useState(false);
  const [topFilterData, setTopFilterData] = useState([]);
  const [tableFilterData, setTableFilterData] = useState([]);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [tableSortData, setTableSortData] = useState(null);
  const [listData, setListData] = useState([]);
  const [tPFilterData, setTPFilterData] = useState([]);
  const [cPFilterData, setCPFilterData] = useState([]);
  const [PIFilterData, setPIFilterData] = useState([]);
  const procedureTaskId = getRoutingParam("ProcedureTaskId");
  const [procedureId, setProcedureId] = useState("");

  const getLatestProcedureId = () => {
    return new Promise((resolve) => {
      changeHistoryService.getProcedureInfoByProcedureTaskId(
        { procedureTaskId },
        async (result: any) => {
          try {
            setProcedureId(result.procedureID);
            resolve(result.procedureID ?? "");
          } catch (error) {
            message.error("Failed To Parse Procedure Data!", 3);
            resolve("");
          }
        },
        () => {
          message.error("Failed To Get Procedure Data!", 3);
          resolve("");
        }
      );
    });
  };

  const tabOptions = [
    { label: "Procedure Change History", value: 1 },
    { label: "PO & Sharing Relationship Change History", value: 2 },
  ];

  const defaultSort = { sortColumn: "ProcessInitiateDate", isAscending: false };

  const resetState = () => {
    setIsExpend(false);
    setTopFilterData([]);
    setTableFilterData([]);
    setFilteredInfo([]);
    setTableSortData(null);
    setListData([]);
    setTPFilterData([]);
    setCPFilterData([]);
    setPIFilterData([]);
  };

  const tabOnChange = ({ target: { value } }: any) => {
    setTab((pre) => value);
    resetState();
  };

  const getProcessCategory = (processCategoryOption: any, processCategorySelect: any) => {
    let filterArr = [];

    filterArr = processCategorySelect.map((x: any) => x);

    return {
      filterColumn: "ProcessCategory",
      filterValue: filterArr,
    };
  };

  const getProcessStatus = (processProcessStatusOption: any, processProcessStatusSelect: any) => {
    let filterArr = [];

    filterArr = processProcessStatusSelect.map((x: any) => x);

    return {
      filterColumn: "ProcessStatus",
      filterValue: filterArr,
    };
  };

  const getTopFilter = (filterOptionList: any, selectOptions: any) => {
    let topFilterArr = [];
    const topFilterOptionList = JSON.parse(JSON.stringify(filterOptionList));
    const topFilterSelectOptions = JSON.parse(JSON.stringify(selectOptions));

    const processCategory = getProcessCategory(
      topFilterOptionList.processCategory,
      topFilterSelectOptions.processCategory
    );
    topFilterArr.push(processCategory);

    const processStatus = getProcessStatus(
      topFilterOptionList.processStatus,
      topFilterSelectOptions.processStatus
    );
    topFilterArr.push(processStatus);

    return topFilterArr;
  };

  const getListSuccess = (result: any) => {
    setListData(result.data);
    setLoading(false);
  };

  const getListError = (result: any) => {
    console.log(result);
  };

  const resetTableState = () => {
    setTableFilterData([]);
    setTableSortData(null);
    setFilteredInfo({});
  };

  const getTriggerProcessFilterSuccess = (result: any) => {
    setTPFilterData(result.data);
    resetTableState();
  };

  const getCurrentProcessorFilterSuccess = (result: any) => {
    setCPFilterData(result.data);
    resetTableState();
  };

  const getProcessInitiatorFilterSuccess = (result: any) => {
    setPIFilterData(result.data);
    resetTableState();
  };

  const fetchProcedureHistory = (isAll: any, getListPara: any) => {
    if (isAll) {
      changeHistoryService.getAllProcedureHistory(getListPara, getListSuccess, getListError);
    } else {
      changeHistoryService.getCurrentProcedureHistory(getListPara, getListSuccess, getListError);
    }
  };

  const handleTopFilterClick = async (filterOptionList: any, selectOptions: any) => {
    const latestProcedureId = await getLatestProcedureId();
    const topFilterArr = getTopFilter(filterOptionList, selectOptions);
    setLoading(true);
    // @ts-ignore
    setTopFilterData(topFilterArr);
    const getListPara = {
      filterFields: topFilterArr,
      sortField: defaultSort,
      procedureTaskId: procedureTaskId,
      procedureIds: [latestProcedureId],
    };

    const para = {
      changeHistoryDto: getListPara,
      isAll: isExpend,
      historyType: 0,
    };
    // @ts-ignore
    changeHistoryService.getTriggerProcessFilter(
      para,
      getTriggerProcessFilterSuccess,
      getListError
    );

    const cpPara = {
      changeHistoryDto: getListPara,
      isAll: isExpend,
      historyType: tab,
    };
    // @ts-ignore
    changeHistoryService.getCurrentProcessorFilter(
      cpPara,
      getCurrentProcessorFilterSuccess,
      getListError
    );
    // @ts-ignore
    changeHistoryService.getProcessInitiatorFilter(
      cpPara,
      getProcessInitiatorFilterSuccess,
      getListError
    );

    if (tab === 1) {
      fetchProcedureHistory(isExpend, getListPara);
    } else {
      changeHistoryService.getTaskHistory(getListPara, getListSuccess, getListError);
    }
  };

  const concatChangeHistoryFilters = (topFilter: any, tableFilter: any) => {
    const mergedArray = [...topFilter];

    for (const objB of tableFilter) {
      const filterColumnB = objB.filterColumn;
      const filterValueB = objB.filterValue;
      const existingObjIndex = mergedArray.findIndex((objA) => objA.filterColumn === filterColumnB);

      if (existingObjIndex !== -1) {
        const existingObj = mergedArray[existingObjIndex];
        const filterValueA = existingObj.filterValue;
        const intersection = filterValueA.filter((value: any) => filterValueB.includes(value));
        existingObj.filterValue = intersection.length > 0 ? intersection : [];
      } else {
        mergedArray.push(objB);
      }
    }

    return mergedArray;
  };

  const handleTableFilterSort = async (tableFilterPara: any, tableSortPara: any, filters: any) => {
    let latestProcedureId = await getLatestProcedureId();
    if (latestProcedureId === "" && isExpend) {
      const routingProcedureId =
        getRoutingParam("ProcedureId") === "null" ? "" : getRoutingParam("ProcedureId");

      latestProcedureId = routingProcedureId;
    }
    const topFiter = JSON.parse(JSON.stringify(topFilterData));
    const tableFilter = JSON.parse(JSON.stringify(tableFilterPara));
    const sort = JSON.parse(JSON.stringify(tableSortPara));
    const filterArr = concatChangeHistoryFilters(topFiter, tableFilter);
    setLoading(true);
    setTableFilterData(tableFilter);
    setTableSortData(sort);
    setFilteredInfo(filters);
    const getToDoListPara = {
      filterFields: filterArr,
      sortField: sort !== null ? sort : defaultSort,
      procedureTaskId: procedureTaskId,
      procedureIds: [latestProcedureId],
    };

    getListTableData(tab, getToDoListPara);
  };

  const getListTableData = (tab: any, getListPara: any) => {
    if (tab === 1) {
      fetchProcedureHistory(isExpend, getListPara);
    } else {
      changeHistoryService.getTaskHistory(getListPara, getListSuccess, getListError);
    }
  };

  const handleExpendButtonClickAction = async (currentIsExpend: any) => {
    let latestProcedureId = await getLatestProcedureId();
    if (latestProcedureId === "" && currentIsExpend) {
      const routingProcedureId =
        getRoutingParam("ProcedureId") === "null" ? "" : getRoutingParam("ProcedureId");

      latestProcedureId = routingProcedureId;
    }
    const topFiter = JSON.parse(JSON.stringify(topFilterData));
    setLoading(true);
    const getListPara = {
      filterFields: topFiter,
      sortField: defaultSort,
      procedureTaskId: procedureTaskId,
      procedureIds: [latestProcedureId],
    };

    const para = {
      changeHistoryDto: getListPara,
      isAll: currentIsExpend,
      historyType: 0,
    };
    // @ts-ignore
    changeHistoryService.getTriggerProcessFilter(
      para,
      getTriggerProcessFilterSuccess,
      getListError
    );

    const cpPara = {
      changeHistoryDto: getListPara,
      isAll: currentIsExpend,
      historyType: tab,
    };
    // @ts-ignore
    changeHistoryService.getCurrentProcessorFilter(
      cpPara,
      getCurrentProcessorFilterSuccess,
      getListError
    );
    // @ts-ignore
    changeHistoryService.getProcessInitiatorFilter(
      cpPara,
      getProcessInitiatorFilterSuccess,
      getListError
    );

    fetchProcedureHistory(currentIsExpend, getListPara);
  };

  const handleExpendButtonClick = () => {
    const currentIsExpend = !isExpend;
    setIsExpend(currentIsExpend);
    handleExpendButtonClickAction(currentIsExpend);
  };

  const mapFilter = (filter: any) => {
    let filterList = [];

    if (filter && filter.length !== 0) {
      filterList = filter.map((item: any) => ({
        text: item.value,
        value: item.key,
      }));
      filterList.sort((a: any, b: any) => {
        const textA = a.text?.toUpperCase();
        const textB = b.text?.toUpperCase();
        if (!textA) return -1;
        if (!textB) return 1;
        if (textA < textB) {
          return -1;
        }
        if (textA > textB) {
          return 1;
        }
        return 0;
      });
    }

    return filterList;
  };

  const handleTableSortOrder = (sortColumnName: any, tableSortData: any) => {
    if (tableSortData?.sortColumn === sortColumnName) {
      return tableSortData.isAscending ? "ascend" : "descend";
    }
    return null;
  };

  const { formatDate, generateGUID } = ListColumnBase();

  const columns = [
    {
      title: "",
      dataIndex: "procedureHeader",
      key: "procedureHeader",
      width: 60,
      onCell: (record: any) => ({
        colSpan: record.procedureHeader !== undefined ? 9 : 1,
      }),
      ellipsis: {
        showTitle: false,
      },
      render: (procedureHeader: any) => (
        <Tooltip placement="topLeft" title={procedureHeader}>
          {procedureHeader}
        </Tooltip>
      ),
    },
    {
      title: "PMP Transaction ID",
      dataIndex: "transactionID",
      key: "transactionID",
      onCell: (record: any) => ({
        colSpan: record.procedureHeader !== undefined ? 0 : 1,
      }),
      ellipsis: {
        showTitle: false,
      },
      render: (transactionID: any) => (
        <Tooltip placement="topLeft" title={transactionID}>
          {transactionID}
        </Tooltip>
      ),
      width: 155,
    },
    {
      title: "Process Category",
      dataIndex: "processCategory",
      key: "processCategory",
      onCell: (record: any) => ({
        colSpan: record.procedureHeader !== undefined ? 0 : 1,
      }),
      dbName: "ProcessCategory",
      sorter: true,
      sortOrder: handleTableSortOrder("ProcessCategory", tableSortData),
      ellipsis: {
        showTitle: false,
      },
      render: (text: any, record: any) => (
        <Tooltip placement="topLeft" title={text}>
          {text === "Archive Procedure" || text === "Archive Task Info." ? (
            text
          ) : (
            <a
              href={
                "/ProcessDetail/" +
                record.processID +
                (text === "Upload Sign-off Confirmation" ? `?returnUrl=${location.pathname}` : "")
              }
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`change-history-process-link-${record.processID}`}
            >
              {text}
            </a>
          )}
        </Tooltip>
      ),
    },
    {
      title: "Trigger Process",
      dataIndex: "triggerProcess",
      key: "triggerProcess",
      onCell: (record: any) => ({
        colSpan: record.procedureHeader !== undefined ? 0 : 1,
      }),
      dbName: "TriggerProcess",
      ellipsis: {
        showTitle: false,
      },
      sorter: true,
      sortOrder: handleTableSortOrder("TriggerProcess", tableSortData),
      filters: mapFilter(tPFilterData),
      // @ts-ignore
      filteredValue: filteredInfo.triggerProcess || null,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, filters }: any) =>
        GetColumnCheckboxGroupFilterDropdown({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          filters,
          filterLoading: false,
        }),
      hidden: tab === 2,
      render: (triggerProcess: any, record: any) => (
        <Tooltip placement="topLeft" title={triggerProcess}>
          <a
            href={"/ProcessDetail/" + record.triggerProcessID}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`change-history-trigger-process-link-${record.triggerProcessID}`}
          >
            {triggerProcess}
          </a>
        </Tooltip>
      ),
    },
    {
      title: "Process Status",
      dataIndex: "processStatus",
      key: "processStatus",
      onCell: (record: any) => ({
        colSpan: record.procedureHeader !== undefined ? 0 : 1,
      }),
      ellipsis: {
        showTitle: false,
      },
      dbName: "ProcessStatus",
      sorter: true,
      sortOrder: handleTableSortOrder("ProcessStatus", tableSortData),
      width: "12rem",
      render: (processStatus: any) => {
        let className;

        switch (processStatus) {
          case "Pending Approval":
            className = "pendingApproval";
            break;
          case "Pending Submission":
            className = "pendingSubmission";
            break;
          case "Rejected":
            className = "reject";
            break;
          case "Reject":
            className = "reject";
            processStatus = "Rejected";
            break;
          case "Approved":
            className = "approval";
            break;
          case "System Termination":
            className = "systemTermination";
            break;
          default:
            className = "";
        }
        return (
          <Tooltip placement="topLeft" title={processStatus}>
            <div className={`MyRequestProcessStatusDiv ${className}`}>{processStatus}</div>
          </Tooltip>
        );
      },
    },
    {
      title: "Process Initiate Date",
      dataIndex: "processInitiateDate",
      key: "processInitiateDate",
      onCell: (record: any) => ({
        colSpan: record.procedureHeader !== undefined ? 0 : 1,
      }),
      ellipsis: {
        showTitle: false,
      },
      dbName: "ProcessInitiateDate",
      sorter: true,
      sortOrder: handleTableSortOrder("ProcessInitiateDate", tableSortData),
      render: (processInitiateDate: any) => (
        <Tooltip placement="topLeft" title={formatDate(processInitiateDate)}>
          {formatDate(processInitiateDate)}
        </Tooltip>
      ),
      width: 180,
    },
    {
      title: "Process Initiator",
      dataIndex: "processInitiator",
      key: "processInitiator",
      onCell: (record: any) => ({
        colSpan: record.procedureHeader !== undefined ? 0 : 1,
      }),
      ellipsis: {
        showTitle: false,
      },
      dbName: "ProcessInitiator",
      sorter: true,
      sortOrder: handleTableSortOrder("ProcessInitiator", tableSortData),
      filters: mapFilter(PIFilterData),
      // @ts-ignore
      filteredValue: filteredInfo.processInitiator || null,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, filters }: any) =>
        GetColumnCheckboxGroupFilterDropdown({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          filters,
          filterLoading: false,
        }),
      render: (processInitiator: any) => (
        <Tooltip placement="topLeft" title={processInitiator}>
          {processInitiator}
        </Tooltip>
      ),
      width: 175,
    },
    {
      title: "Current Processor",
      dataIndex: "currentProcessor",
      key: "currentProcessor",
      dbName: "CurrentProcessor",
      sorter: true,
      sortOrder: handleTableSortOrder("CurrentProcessor", tableSortData),
      onCell: (record: any) => ({
        colSpan: record.procedureHeader !== undefined ? 0 : 1,
      }),
      ellipsis: {
        showTitle: false,
      },
      filters: mapFilter(cPFilterData),
      // @ts-ignore
      filteredValue: filteredInfo.currentProcessor || null,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, filters }: any) =>
        GetColumnCheckboxGroupFilterDropdown({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          filters,
          filterLoading: false,
        }),
      render: (currentProcessor: any) => (
        <Tooltip placement="topLeft" title={currentProcessor}>
          {currentProcessor}
        </Tooltip>
      ),
    },
    {
      title: "Process Completed Date",
      dataIndex: "processCompletedDate",
      key: "processCompletedDate",
      dbName: "ProcessCompletedDate",
      onCell: (record: any) => ({
        colSpan: record.procedureHeader !== undefined ? 0 : 1,
      }),
      ellipsis: {
        showTitle: false,
      },
      sorter: true,
      sortOrder: handleTableSortOrder("ProcessCompletedDate", tableSortData),
      render: (processCompletedDate: any) => (
        <Tooltip placement="topLeft" title={formatDate(processCompletedDate)}>
          {formatDate(processCompletedDate)}
        </Tooltip>
      ),
      width: 210,
    },
  ];

  const transformData = (data: any) => {
    if (!data) {
      return;
    }

    if (Array.isArray(data)) {
      for (let i = 0; i < data.length; i++) {
        transformData(data[i]);
      }
    } else if (typeof data === "object") {
      data.key = generateGUID();

      if (data.procedureHistoryVo && Array.isArray(data.procedureHistoryVo)) {
        data.children = data.procedureHistoryVo;
        delete data.procedureHistoryVo;

        for (let i = 0; i < data.children.length; i++) {
          transformData(data.children[i]);
        }
      }
    }
  };

  transformData(listData);

  return (
    <NormalSpin
      spinning={loading}
      size="large"
      children={
        <div className={styles.procedureListDiv}>
          <div className={styles.procedureTopFilter}>
            <div className={`${toDoListStyles.tabDiv} tabDiv`}>
              <Radio.Group
                onChange={tabOnChange}
                value={tab}
                optionType="button"
                data-testid="change-history-tab-group"
              >
                <Radio.Button value={1} data-testid="change-history-procedure-tab">
                  Procedure Change History
                </Radio.Button>
                <Radio.Button value={2} data-testid="change-history-po-sharing-tab">
                  PO & Sharing Relationship Change History
                </Radio.Button>
              </Radio.Group>
            </div>
            <TopFilter
              tab={tab}
              handleFilterClick={handleTopFilterClick}
              procedureId={procedureId}
              procedureTaskId={procedureTaskId}
            />
          </div>
          <div className={styles.tableDiv}>
            <div className={changeHistoryStyle.chTableDiv}>
              {tab === 1 && (
                <div className={changeHistoryStyle.expendButtonDiv}>
                  <Tooltip placement="left" title="Show active and all archived procedure folders.">
                    <Buttons
                      color="white-blue"
                      size="small"
                      onClick={handleExpendButtonClick}
                      testid="change-history-toggle-btn"
                    >
                      {isExpend ? "Collapse" : "Show All"}
                    </Buttons>
                  </Tooltip>
                </div>
              )}

              <ChangeHistoryListTable
                columns={columns}
                data={listData}
                tableFilterMap={changeHistoryFilterMap}
                handleFilterSort={handleTableFilterSort}
                handleFilterClick={handleTopFilterClick}
                tab={tab}
              />
            </div>
          </div>
        </div>
      }
    />
  );
}
